import React from "react";
import { useI18n } from "../i18n";

/**
 * Light-themed modal shell for admin-dashboard pages — a fixed overlay,
 * centered on desktop and full-screen on phones, matching the markup
 * ProductForm already used inline. Anything that used to be a block appended
 * to the bottom of a page (easy to add, easy to miss until you scroll down)
 * should render through this instead.
 */
const Modal = ({ title, onClose, children, maxWidthClass = "max-w-4xl", zClass = "z-50" }) => {
  const { t } = useI18n();

  return (
    <div
      // Some pages render this as the last child of a `space-y-6` section —
      // Tailwind's `space-y-*` puts a margin-top on every child after the
      // first, fixed positioning or not, which would push this overlay down
      // from the viewport's actual top. An inline style is the one thing
      // guaranteed to outrank that rule regardless of which page mounts it.
      style={{ marginTop: 0 }}
      className={`fixed inset-0 bg-black bg-opacity-50 flex items-start sm:items-center justify-center ${zClass} p-0 sm:p-4`}
    >
      <div
        className={`bg-white sm:rounded-xl shadow-2xl ${maxWidthClass} w-full max-h-[100vh] sm:max-h-[90vh] overflow-y-auto`}
      >
        <div className="sticky top-0 bg-white border-b px-6 py-4 flex items-center justify-between gap-3">
          <h2 className="text-2xl font-bold text-gray-800">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            aria-label={t("common.close")}
            className="text-gray-500 hover:text-gray-700 text-2xl leading-none"
          >
            ✕
          </button>
        </div>

        <div className="p-6">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
